import { useMutation, useQuery, useQueryClient } from "react-query";
import { QUERY } from "../../constants/query";
import { useApiService } from "../useApiService";
import { FamilyControllerService } from "../../services";

export const useGetAllFamily = (propertyId: string) => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_FAMILY];

  const query = useQuery(queryKey, () =>
    handleRequest(FamilyControllerService.familyControllerGetFamily(propertyId))
  );

  return {
    ...query,
  };
};

export const useAddFamilyMembers = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    ({
      requestBody,
      propertyId,
    }: {
      requestBody: {
        id?: string;
        name: string;
        relationship: string;
        occupation?: string;
        dob: string;
        dot?: string;
        birthPlace?: string;
        problemFacing: string[];
      }[];
      propertyId?: string;
    }) =>
      handleRequest(
        FamilyControllerService.familyControllerCreateFamily(
          requestBody,
          propertyId
        )
      ),
    {
      onSuccess: (response) => {
        console.log("Family member added successfully:", response);
        queryClient.invalidateQueries(QUERY.GET_ALL_FAMILY);
      },
    }
  );
  return {
    ...mutation,
  };
};
